import { useMemo } from 'react';
import _ from 'lodash';

import { useCoverageLevelsStore } from '../stores';

export default () => {
  const coverageLevels = useCoverageLevelsStore((state) => state.state);

  const sortedLevels = useMemo(
    () =>
      _.orderBy(coverageLevels, [(item) => item.isDeletable, (item) => _.toLower(item.name)], ['asc', 'asc']),
    [coverageLevels]
  );

  const excludeIds = useMemo(() => coverageLevels.map((item) => item.coverageId || ''), [coverageLevels]);

  return {
    levels: sortedLevels,
    excludeIds,
  };
};
